import { useAuthStore } from '~/stores/use-auth-store';

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig();
  const matomoUrl = config.public.matomoUrl as string;
  const siteId = config.public.matomoSiteId as string;

  if (!matomoUrl || !siteId) return;

  window._paq = window._paq || [];
  window._paq.push(['setTrackerUrl', `${matomoUrl}/matomo.php`]);
  window._paq.push(['setSiteId', siteId]);
  window._paq.push(['setCookieDomain', '.arvee.io']);
  window._paq.push([
    'setDomains',
    ['*.arvee.io', '*.frontend.arvee.io', '*.tools.arvee.io'],
  ]);
  window._paq.push(['enableCrossDomainLinking']);
  window._paq.push(['enableLinkTracking']);

  const script = document.createElement('script');
  script.async = true;
  script.src = `${matomoUrl}/matomo.js`;
  document.head.appendChild(script);

  const nuxtApp = useNuxtApp();
  const route = useRoute();
  nuxtApp.hook('page:finish', () => {
    // Unhead patches `document.title` via a debounced `setTimeout(fn, 0)`
    // (see `@unhead/vue/dist/client.mjs`). `nextTick` only flushes Vue's
    // microtask queue, so the Unhead macrotask hasn't fired yet and we'd
    // read the previous page's title. Queue our own `setTimeout(0)` after
    // Unhead's so macrotask FIFO ordering gives us the patched title.
    setTimeout(() => {
      // Strip the SSO `code` param from /auth/callback page-views so the
      // one-time exchange code never reaches Matomo. Preserve `next=` so
      // multi-step flows (e.g., redirect_to=/claim/abc) remain analyzable.
      const trackedUrl =
        route.path === '/auth/callback'
          ? '/auth/callback' +
            (route.query.next
              ? '?next=' + encodeURIComponent(String(route.query.next))
              : '')
          : route.fullPath;
      window._paq!.push(['setCustomUrl', trackedUrl]);
      window._paq!.push(['setDocumentTitle', document.title]);
      window._paq!.push(['trackPageView']);
    }, 0);
  });

  const authStore = useAuthStore();
  const { setUserId, resetUserId } = useMatomo();

  watch(
    () => authStore.user,
    (user) => {
      if (user) {
        setUserId(String(user.id));
      } else {
        resetUserId();
      }
    },
    { immediate: true },
  );
});
